<div class="font-main font-bold text-sm text-navy-90 flex items-center">
  {{ headerText }}
  @if (infoText) {
    <app-info-icon class="flex ml-1" [tooltipText]="infoText" [tooltipPosition]="tooltipPosition"></app-info-icon>
  }
</div>
